import type { DeviceMode, DrawerState, PreviewMode, SelectedEntity } from '@common/types/layout.type';

import { createActionGroup, emptyProps, props } from '@ngrx/store';

const LayoutActions = createActionGroup({
    source: 'Layout',
    events: {
        'Set selected entity': props<{ selectedEntity: SelectedEntity; scrollTo?: boolean }>(),
        'Hide selected entity settings': emptyProps(),
        'Unset entity': emptyProps(),
        'Show preview': emptyProps(),
        'Change preview mode': props<{ previewMode: PreviewMode }>(),
        'Hide preview': emptyProps(),
        'Change device mode': props<{ deviceMode: DeviceMode }>(),
        'Open drawer': props<{ drawerState: DrawerState }>(),
        'Close drawer': emptyProps(),
        'Set is entity dragging': props<{ isEntityDragging: boolean }>(),
        'Set column width changing': props<{ isColumnWidthChanging: boolean }>(),
        'Toggle page drawer': emptyProps(),
        'Set is hide column controls': props<{ isHideColumnControls: boolean }>(),
        'Set settings panel position': props<{ x: number; y: number }>(),
        'Set ai reply active': props<{ active: boolean }>(),
        'Set element picker active': props<{ active: boolean }>(),
    },
});

export default LayoutActions;
